<script setup lang="ts">
import { computed } from 'vue'
import { useRuntimeStore } from '../stores/runtime'
const store = useRuntimeStore()
const bitrix = computed(() => store.session?.context?.bitrix)
const serviceUrl = import.meta.env.VITE_SERVICE_URL || '#'
</script>
<template>
  <section>
    <div class="page-head"><div><h1>Подключение</h1><p>Состояние текущей интеграции Bitrix24.</p></div></div>
    <div class="info-card">
      <dl><dt>Портал</dt><dd>{{ bitrix?.domain || '—' }}</dd><dt>member_id</dt><dd>{{ bitrix?.member_id || '—' }}</dd></dl>
      <a class="button primary" :href="serviceUrl" target="_blank" rel="noopener">Открыть управление S-A-S Forms</a>
    </div>
  </section>
</template>
